import createLeadFieldSelect from "./createLeadFieldSelect";

export default createLeadFieldSelect("/leads/all_companies", {
  displayName: "CompanySelect",
  defaultPlaceholder: "Select Companies",
});
